var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 27.178,
    viewBox: "0 0 32 27.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-credit-card-7438039",
    d: "M69.272,165.938a.485.485,0,0,1,0-.969h8.11a.485.485,0,1,1,0,.969Zm14.755-3.792h4.808a.725.725,0,0,1,.724.724v2.344a.726.726,0,0,1-.724.724H84.027a.726.726,0,0,1-.724-.724V162.87a.725.725,0,0,1,.724-.724Zm4.562.969H84.273v1.853H88.59Zm-22.416,2.169v1.829a1.427,1.427,0,0,0,1.426,1.426H90.625a1.427,1.427,0,0,0,1.426-1.426V153.2a1.427,1.427,0,0,0-1.426-1.426H88.247l-4.521-7.83-.014-.026-.015-.025L82.665,142.1c0-.01-.01-.018-.014-.026a1.425,1.425,0,0,0-1.944-.521L60.764,153.066a1.425,1.425,0,0,0-.522,1.946h0l5.931,10.272ZM61.079,154.53h0a.465.465,0,0,1,.167-.625l19.939-11.512a.463.463,0,0,1,.626.169l.015.025.806,1.394-13.5,7.793H67.6a1.427,1.427,0,0,0-1.426,1.426v.285L61.9,155.952l-.819-1.419Zm1.3,2.256,3.792-2.189v1.268l-3.243,1.872-.55-.951Zm1.032,1.787,2.76-1.593v6.375l-2.76-4.78Zm23.718-6.8H75.2l8.951-5.168,2.983,5.168Zm-3.467-6-10.4,6H71.07l12.046-6.955.549.95ZM67.144,156.9V155.8H91.081V156.9H67.142Zm23.937.969H67.142v9.246a.46.46,0,0,0,.457.457H90.624a.46.46,0,0,0,.457-.457Zm-23.937-3.033V153.2a.46.46,0,0,1,.457-.457H90.626a.46.46,0,0,1,.457.457v1.639H67.143Zm2.129,8.765a.485.485,0,1,1,0-.969h4.218a.485.485,0,1,1,0,.969Z",
    transform: "translate(-60.051 -141.363)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.f753d26d5fcb9a8e8a09fd041e4f32b5.svg";
export { ForwardRef as ReactComponent };